/** @jsx h */
import { h, render } from 'preact';
import './fym-promotions.global.css';
import App from '../../../promotions/app/components/fym-uds-promotions';

export const ForwardMailPromotionsComponent = {
  template: `
    <div>
      <div ng-if="$ctrl.interactor && !$ctrl.interactor.isHidden()">
        <ng-transclude></ng-transclude>
      </div>
      <div class="promotions-mount-point"></div> 
    </div>
  `,
  bindings: {
    interactor: '<',
    selfContained: '<',
    afterClaim: '<',
  },
  transclude: true,
  controller: class {
    constructor($element) {
      'ngInject';
      this.mountPoint = $element[0].querySelector('.promotions-mount-point');
    }

    $postLink() {
      const renderApp = () => {
        render(
          <App interactor={this.interactor}>
            {this.selfContained && (
              <upd-cta primary>
                <button
                  type="button"
                  onClick={() =>
                    this.interactor
                      .claimPromotions()
                      .then(() => this.afterClaim && this.afterClaim())
                  }
                >
                  Claim Deals ({this.interactor.numberOfDealsSelected()})
                </button>
              </upd-cta>
            )}
          </App>,
          this.mountPoint
        );
      };
      this.unsub = this.interactor.subscribe(renderApp);
    }

    $onDestroy() {
      this.unsub && this.unsub();
    }
  },
};
